import React, { useState } from 'react';
import Grid from './Grid';
import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { IconButton, OutlinedInput, InputAdornment, Avatar, Typography, Box, Tabs, Tab, MenuItem, Button } from '@mui/material';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
import StyledPopup from '../../../components/StyledMenu';
import AlertDialog from '../../../components/modals/InventoryModal';
import ThreshHold from '../../../components/modals/ThreshHold';
import BackButton from '../../../utils/BackButton';
import { useGetUnits } from '../../../services/stores';
import { useSelector } from 'react-redux';
import ProductUnits from '../Modals/Units';
import AddItem from '../Modals/Additems';

const BorderLinearProgress = styled(LinearProgress)(({ barColor, pathColor }) => ({
    height: 5,
    width: 150,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: pathColor
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: barColor
    },
}));

const StoreInventory = () => {
    const [currentTab, setCurrentTab] = useState(0);
    const [anchorEl, setAnchorEl] = useState(null);
    const [alert, setAlert] = useState(false);
    const [threshold, setThreshold] = useState(false)

    function getColor(remainder, total) {
        const p = (remainder / total) * 100;

        return p > 35 && p < 50 ? { bar: "#F4B315", path: "#FFD7D7" } : p < 35 ? { bar: "#F20C33", path: "#FFD7D7" } : { bar: "#3FA782", path: "#DFFFF4" }
    }

    function getValue(remainder, total) {
        const p = (remainder / total) * 100;
        return Math.floor(p)
    }

    const columns = [
        {
            field: "product",
            headerName: "Product",
            flex: 1,
            renderCell: (param) => (
                <Box display={"flex"} alignItems={"center"} columnGap={2}>
                    <Avatar src={param.row.image} />
                    <Typography sx={{ opacity: "80%" }}>{param.row.product}</Typography>
                </Box>
            )
        },
        {
            field: "value",
            headerName: "Value",
            flex: 1,
            renderCell: (param) => (
                <Typography sx={{ opacity: "80%" }}>{param.row.value.toLocaleString("en", {
                    style: "currency",
                    currency: "usd",
                })}</Typography>
            )
        },
        {
            field: "inStock",
            headerName: "In Stock",
            flex: 1,
            renderHeader: () => (
                <Box display={"flex"} alignItems={"center"} columnGap={1}>
                    <Typography sx={{ fontWeight: 600 }}>In Stock</Typography>
                    {Array(3).fill(0).map((__, i) => (
                        <Box sx={{
                            height: 16,
                            width: 16,
                            borderRadius: "50%",
                            border: `1px solid ${i === 0 ? "#3FA782" : i === 1 ? "#F4B315" : "#F20C33"}`
                        }} />
                    ))}
                </Box>
            ),
            renderCell: (param) => (
                <Box width={150}>
                    <Typography sx={{ fontWeight: 600, textAlign: "center" }}>{param.row.remainder}/{param.row.total}</Typography>
                    <BorderLinearProgress
                        variant="determinate"
                        value={getValue(param.row.remainder, param.row.total)}
                        barColor={getColor(param.row.remainder, param.row.total).bar}
                        pathColor={getColor(param.row.remainder, param.row.total).path}
                    />
                </Box>
            )
        },
        {
            field: "Action",
            renderCell: (param) => (
                <>
                    <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
                        <MoreHorizIcon />
                    </IconButton>

                    <StyledPopup open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
                        {[{ name: "Delete", onClick: () => setAlert(true) }, { name: "Set threshold", onClick: () => setThreshold(true) }].map((a, i) => (
                            <MenuItem
                                onClick={() => { a.onClick(); setAnchorEl(null) }}
                                disableRipple
                                key={i}
                            >
                                {a.name}
                            </MenuItem>
                        ))}
                    </StyledPopup>
                </>
            )
        }
    ];

    const rows = [
        {
            product: "Potato",
            value: 128083,
            image: "https://i.pinimg.com/564x/1b/ac/75/1bac7535fe4b5d174b71d1b9ad0901d5.jpg",
            total: 190,
            remainder: 10
        },
        {
            product: "Tomato",
            value: 689273,
            image: "https://i.pinimg.com/736x/e4/62/bc/e462bc43c9a3619a338eeac9f7e4eb72.jpg",
            total: 260,
            remainder: 220
        },
        {
            product: "Carrot",
            value: 684,
            image: "https://i.pinimg.com/564x/f0/cd/b6/f0cdb625a5a2688de8d37e3607d19efd.jpg",
            total: 280,
            remainder: 120
        }
    ]

    const tabOptions = ["Vegetables", "Fruits", "Drinks", "Utensils", "Cleaning"]
    const { currentBranch } = useSelector((state) => state.branch);
    const branchId = currentBranch?.id;
    const { units, isLoading } = useGetUnits(branchId);
    console.log('My units', units)

    const [openCreateUnit, setOpenCreateUnit] = useState(false);
    const [openCreateItem, setOpenCreateItem] = useState(false);




    return (
        <div className='space-y-8'>
            <div className='flex justify-between items-center'>
                <Box sx={{ display: "flex" }}>
                    <h2 className='text-3xl font-bold'>Inventory</h2>
                    <BackButton />
                </Box>
                {/* Header */}

                <Button
                    variant="contained"
                    onClick={() => setOpenCreateItem(true)}
                >
                    + Add Item
                </Button>


            </div>
            {/* <OutlinedInput
                    sx={{ width: 400, mt: 4 }}
                    size='small'
                    placeholder='Search'
                    // onChange={(e) => setSearchValue(e.target.value)}
                    // value={searchValue || ''}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                // onClick={() => setSearchValue(null)}
                                edge="end"
                                sx={{ backgroundColor: "#F4B315", borderRadius: 1 }}
                            >
                                <SearchIcon sx={{ color: "white" }} />
                            </IconButton>
                        </InputAdornment>
                    }
                /> */}

            <div className='w-full border border-[#ECECEC]'>
                <Box sx={{ paddingX: 1, paddingTop: 1 }}>
                    <Tabs value={currentTab} aria-label="tab">
                        {tabOptions.map((tab) => (
                            <Tab key={tab} label={tab} sx={{ fontWeight: 600, fontSize: 16 }} />
                        ))}
                    </Tabs>
                </Box>

                <Grid columns={columns} rows={rows} />
            </div>

            <AlertDialog open={alert} onClose={() => setAlert(false)} />
            <ThreshHold open={threshold} onClose={() => setThreshold(false)} />



            <ProductUnits
                visible={openCreateUnit}
                handleCancelButton={() => setOpenCreateUnit(false)}
                restaurant_id={branchId}
            />
            <AddItem
                visible={openCreateItem}
                setOpen={setOpenCreateUnit}
                handleCancelButton={() => setOpenCreateItem(false)} />
        </div>
    )
}

export default StoreInventory